import { Box, EmptyState } from '@dixa/lib-shared-habla';

type EmptyItemProps = {
  /** The search term. */
  searchTerm: string;
};

/** Represents an empty item. */
export const EmptyItem = ({ searchTerm }: EmptyItemProps): JSX.Element => {
  return (
    <Box as="li" padding="200 300">
      <EmptyState
        title={
          searchTerm.length === 0
            ? 'No tags available'
            : 'No tags match the criteria'
        }
        description={
          searchTerm.length === 0
            ? 'Try typing a tag name to quick add or go to tag settings'
            : 'Try changing your search criteria or create a new one'
        }
      />
    </Box>
  );
};
